import { Injectable } from '@angular/core';

@Injectable()

export class BOOKTYPES {
    public static readonly COMICBOOK: string = 'COMIC BOOKS';
    public static readonly PICTUREBOOK: string = 'PICTURE BOOKS';
}

export class BASEURLS {
    public static readonly S3URL: string = 'https://littlechamps.s3.ap-south-1.amazonaws.com/images/';
}

export class CATEGORYTYPES {
    public static readonly HYGIENEVIDEOS: string = "Happy Bot's Hygiene Videos";
    public static readonly ADVENTUREHYGIENE: string = 'Adventure Hygiene';
    public static readonly SPECIALCARE: string = "Happy Bot's Special Care Videos";
}


export class LISTTYPE {
    public static readonly SERIES: string = 'SERIES';
    public static readonly CATEGORY: string = 'CATEGORY';
}

export class PARENTCATEGORYTYPES {
    public static readonly VIDEOS: string = 'VIDEOS';
    public static readonly EBOOKS: string = 'EBOOKS';
}